// name to identify simple space not to be removed
export const space = ' ';
